//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { sysRoles_insert, sysRoles_update, sysRoles_detail, sysEnts_showTree, sysRoleEntRelas } from '@/apis/system'

export default {
    data() {
        //表單校驗
        const rules = {
            roleName: [{ required: true, message: '請輸入角色名稱！' }],
            checkedKeys: [{ required: true, message: '請輸入角色權限！' }],
        };

        const form = {
            recordId: '',
            roleName: '',
            checkedKeys: []
        };

        return {
            id: '',
            form,
            rules,
            spinning: true,
            config: {
                //權限內容
                treeData: []
            },
            labelCol: { style: { width: '150px', }, },
            wrapperCol: { span: 14, },
        }
    },
    async mounted() {
        this.id = this.$route.params.id;
        await this.onPageConfig();
        if (this.id) {
            await this.onPageLoad();
        }
        this.spinning = false;
    },
    methods: {
        async onPageConfig() {
            const res = await sysEnts_showTree();
            const data = res.data;
            const executeTraverse = (items) => {
                if (items && items.length > 0) {
                    let array = [];
                    for (let i = 0; i < items.length; i++) {
                        const item = items[i];
                        array.push({
                            title: item.entName,
                            key: item.entId,
                            disabled: item.state != 1,
                            children: executeTraverse(item.children),
                            scopedSlots: { title: 'title' }
                        });
                    }
                    return array;
                }
                return [];
            }
            this.config.treeData = executeTraverse(data);

            console.log(this.config.treeData);
        },
        async onPageLoad() {
            try {
                const res = await sysRoles_detail(this.id);
                if (res.code == 0) {
                    const item = res.data || {};
                    const form = { ...this.form };
                    form.roleName = item.roleName;
                    form.id = this.id;
                    this.form = form;

                    const relasRes = await sysRoleEntRelas({ roleId: this.id, pageNumber: 1, pageSize: 9999 });
                    const entIds = relasRes.data.records.map(item => item.entId);
                    this.form.checkedKeys = entIds;
                } else {
                    this.$message.error(res.msg);
                }
            } catch (error) {
                this.$message.error(error.message);
            }
        },
        handleOnCheck(selectedKeys, e) {
            if (this.form.checkedKeys.length > 0) {
                this.$refs.permissionItem.clearValidate();
            }
        },
        async handleFormValidate(e) {
            e.preventDefault();
            this.$refs.form.validate(async valid => {
                if (valid) {
                    await this.onSubmit();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        async onSubmit() {
            try {
                this.spinning = true;
                const submitForm = {
                    ...this.form,
                    entIdListStr: JSON.stringify(this.form.checkedKeys)
                };
                if (this.id) {
                    //update
                    submitForm.recordId = this.id;
                    const res = await sysRoles_update(submitForm);
                    if (res.code == 0) {
                        this.$message.success('編輯完成');
                        this.$router.push('/security/role');
                    }
                } else {
                    //insert
                    const res = await sysRoles_insert(submitForm);
                    if (res.code == 0) {
                        this.$message.success('提交完成');
                        this.$router.push('/security/role');
                    }
                }
            } catch (error) {
                this.$message.error(error.message);
            } finally {
                this.spinning = false;
            }
        }
    }
}
